import { type ComponentType } from 'react'

import { IntegrationServiceId } from '../../../common/integrations'
import { type CrossClientAction, type CrossClientQueryResult } from '../../../models/CrossClient'
import { WealthboxTagsActionModal } from './modals/WealthboxTagsActionModal'
import { WealthboxNoteActionModal } from './modals/WealthboxNoteActionModal'

export type CrmActionKind = 'wealthbox-tag' | 'wealthbox-note'

export interface CrmActionModalProps {
  open: boolean
  onClose: () => void
  resolveResults: () => Promise<CrossClientQueryResult[]>
}

export interface CrmActionDescriptor {
  serviceId: IntegrationServiceId
  label: string
  icon: string
  inProgressLabel: string
  completedLabel: string
  Modal: ComponentType<CrmActionModalProps>
}

export const CRM_ACTION_REGISTRY: Record<CrmActionKind, CrmActionDescriptor> = {
  'wealthbox-tag': {
    serviceId: IntegrationServiceId.WEALTHBOX,
    label: 'Assign tags',
    icon: 'bi-tag',
    inProgressLabel: 'Assigning tag in Wealthbox',
    completedLabel: 'Assigned tag in Wealthbox',
    Modal: WealthboxTagsActionModal,
  },
  'wealthbox-note': {
    serviceId: IntegrationServiceId.WEALTHBOX,
    label: 'Add notes',
    icon: 'bi-journal-text',
    inProgressLabel: 'Adding note in Wealthbox',
    completedLabel: 'Added note in Wealthbox',
    Modal: WealthboxNoteActionModal,
  },
}

const CRM_ACTION_KIND_BY_CONNECTOR_AND_TYPE: Record<string, CrmActionKind> = {
  'wealthbox.tag': 'wealthbox-tag',
  'wealthbox.note': 'wealthbox-note',
}

export const resolveCrmActionKind = (action: CrossClientAction): CrmActionKind | null => {
  const connector = action.details?.connector
  if (typeof connector !== 'string') {
    return null
  }
  return CRM_ACTION_KIND_BY_CONNECTOR_AND_TYPE[`${connector}.${action.actionType}`] ?? null
}
